import { area } from './getAreaData.js'
/**
 * 常用工具类
 * */

/**
 * @function openWindowWithTagA 通过A标签的方式打开新的页面，这种方式相较于window.open方法，不会被浏览器默认阻止
 * @param {String} url 要打开的地址
 * @param {String} openType 打开方式：新窗口还是当前页面
 * */
export const openWindowWithTagA = (url, openType = '_blank') => {
  if (!url) return false
  let a = document.createElement('a')
  let customClickEvent = new MouseEvent('click', {'bubbles': false})
  a.href = url
  a.target = openType
  a.style.display = 'none'
  document.body.appendChild(a)
  a.dispatchEvent(customClickEvent)
  document.body.removeChild(a)
}

/**
 * 监听dom元素变动
 * @param { Function } callback 触发监听的回调
 * @param { HTMLElement } dom 需要监听的dom元素
 * @param { MutationObserverInit } attrs 需要监听的dom配置 具体可看文档配置
 * @return { MutationObserver } 返回监听的实例
 * */
export const watchDom = (callback = () => {}, dom, attrs = {
  childList: true, // 子节点的变动（新增、删除或者更改）
  attributes: true, // 属性的变动
  characterData: true, // 节点内容或节点文本的变动
  subtree: true // 是否将观察器应用于该节点的所有后代节
}) => {
  if (!window.MutationObserver || typeof window.MutationObserver !== 'function') return console.error('浏览器不支持MutationObserver')
  // 如果没有传递要监听的dom，默认监听 #app
  if (!dom) dom = document.getElementById('app')
  const observer = new MutationObserver(callback)
  observer.observe(dom, attrs)
  return observer
}

/**
 * 监听元素宽高发生变化
 * */

export const watchResize = (dom, callback = () => {}) => {
  if (!window.ResizeObserver || typeof window.ResizeObserver !== 'function') return console.error('浏览器不支持ResizeObserver')
  // 如果没有传递要监听的dom，默认监听 #app
  if (!dom) dom = document.getElementById('app')
  const observer = new ResizeObserver(entries => callback(entries))
  observer.observe(dom)
  return observer
}

/**
 * 判断字符串转化为时间是否有效
 * @param {string} str
 * @return {Boolean} 返回时间是否有效
 * */
export const isValidaDate = str => {
  if (str === '') return false
  const date = new Date(str)
  return date instanceof Date && date.toString() !== 'Invalid Date' && !isNaN(Date.parse(date))
}

/**
 * 获取文本在一定宽度时的高度
 * @param { String } width 宽度，默认100px
 * @param { String } text 文本内容
 * @return { Number } height 返回计算后的高度
 * */
export const textHeight = (width = '100px', text) => {
  const newDiv = document.createElement('div')
  newDiv.style.width = width
  newDiv.style.visibility = 'hidden'
  newDiv.innerText = text
  document.body.appendChild(newDiv)
  const height = newDiv.getBoundingClientRect().height
  newDiv.parentNode.removeChild(newDiv)
  return height
}

export const textWidth = (text, fontsize) => {
  const newSpan = document.createElement('span')
  newSpan.style.fontSize = fontsize
  newSpan.style.visibility = 'hidden'
  newSpan.innerText = text
  document.body.appendChild(newSpan)
  const width = newSpan.offsetWidth
  newSpan.parentNode.removeChild(newSpan)
  return width + 2
}
/**
 *通过闭包的方式缓存地址码
 * @return { Function } 返回缓存中的地址对象
 * */
export const getArea = area()



// WEBPACK FOOTER //
// ./src/utils/index.js